import ChessRestClient from '@/Api/ChessRestClient';
import {getLocalStorage} from '@/Utils/CommonUtils';
import {useMutation, useQuery} from '@tanstack/react-query';

export default function useRequestUserRelations(
  handleOnSuccess?: (data: any) => void,
  handleOnError?: (error: any) => void,
) {
  const mutation = useMutation<
    any,
    Error,
    {
      mobile_number: string;
      access_type: string;
    }
  >(
    async ({mobile_number, access_type}) => {
      const token = await getLocalStorage('access_token');

      const body = {
        mobile_number,
        access_type,
      };

      const options = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };

      const response = await ChessRestClient.post(
        'dashboard/v1/request-user-relations',
        body,
        options,
      );

      return response.data;
    },
    {
      onSuccess: data => {
        handleOnSuccess?.(data);
      },
      onError: error => {
        handleOnError?.(error);
      },
    },
  );

  return {...mutation};
}

export function useUpdateRelationInvite(
  handleOnSuccess?: (data: any) => void,
  handleOnError?: (error: any) => void,
) {
  return useMutation<
    any,
    Error,
    {
      update_type: number;
      invitation_key: string;
    }
  >(
    async ({update_type, invitation_key}) => {
      const token = await getLocalStorage('access_token');

      const body = {
        update_type,
        invitation_key,
      };

      const options = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };

      const response = await ChessRestClient.post(
        'dashboard/v1/update_relation_invite',
        body,
        options,
      );

      return response.data;
    },
    {
      onSuccess: data => {
        handleOnSuccess?.(data);
      },
      onError: error => {
        handleOnError?.(error);
      },
    },
  );
}

export function useGetRelationInvites(
  relation_type: 0 | 1,
  handleOnSuccess?: (data: any) => void,
  handleOnError?: (error: any) => void,
) {
  return useQuery<any, Error>(
    ['get-relation-invites', relation_type],
    async () => {
      const token = await getLocalStorage('access_token');

      const options = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params: {
          relation_type,
        },
      };

      const response = await ChessRestClient.get(
        'dashboard/v1/get_relation_invites',
        options,
      );

      return response.data;
    },
    {
      onSuccess: data => {
        handleOnSuccess?.(data);
      },
      onError: error => {
        handleOnError?.(error);
      },
    },
  );
}
